import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import ContrastIndicator from '@/common/components/ContrastIndicator/ContrastIndicator'

import BlockSettingField from '../BlockSettingField/BlockSettingField'
import { getVisibleFields } from './helpers'
import * as Styles from './styles'

const BlockSettingsSection = ({ section, settings, onChangeSetting, onUploadImage, canUploadImage }) => {
  const { t } = useTranslation()

  const visibleFields = getVisibleFields(section.fields, settings)
  const contrastField = section.fields.find(field => field.contrastAgainst)

  return (
    <Styles.Container>
      <Text type="titleS">{t(section.title)}</Text>
      {section.description && <Text type="bodyMRegular">{t(section.description)}</Text>}
      <Styles.Fields>
        {visibleFields.map(field => (
          <BlockSettingField
            key={field.key}
            field={field}
            value={settings[field.key]}
            onChange={onChangeSetting}
            onUploadImage={onUploadImage}
            canUploadImage={canUploadImage}
          />
        ))}
      </Styles.Fields>
      {contrastField && (
        <ContrastIndicator
          color={settings[contrastField.key]}
          contrastColor={settings[contrastField.contrastAgainst]}
        />
      )}
    </Styles.Container>
  )
}

export default BlockSettingsSection
